// Reads the "modules" querystring param (e.g. ?modules=7.2%20kWh, set by the
// keuzehulp result CTA — see assets/keuzehulp.js) and pre-selects the
// matching "Aantal modules" variant-picker pill on page load, so the
// recommended variant (price, media) is shown without the visitor having to
// pick it again themselves.
(function () {
  const wanted = new URLSearchParams(window.location.search).get('modules');
  if (!wanted) return;

  // Variant option values on the product can be entered with a comma
  // ("7,2 kWh") or a dot ("7.2 kWh"); normalize both sides before comparing
  // so either notation matches.
  function normalize(value) {
    return value.trim().toLowerCase().replace(',', '.').replace(/\s+/g, ' ');
  }

  const normalizedWanted = normalize(wanted);

  document.querySelectorAll('variant-selects').forEach((variantSelects) => {
    const input = Array.from(variantSelects.querySelectorAll('input[type="radio"]')).find(
      (candidate) => normalize(candidate.value) === normalizedWanted
    );

    if (!input || input.checked) return;

    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
